/**
 * Check if the browser can render the file (handles HEIC on non-Safari browsers)
 * @param {string} url - The file URL or name to check
 * @returns {boolean} Whether the browser can render the file
 */
export function checkBrowserCanRender(url) {
    return (
        (url?.toLowerCase()?.includes('.heic') &&
            /^((?!chrome|android).)*safari/i.test(navigator.userAgent)) ||
        !url?.toLowerCase()?.includes('.heic')
    );
}

/**
 * Get the icon color for a file type based on the theme
 * @param {object} theme - The theme object
 * @param {string} fileType - The file type (pdf, xls, doc, ppt, img, zip, etc.)
 * @returns {string} The color value from the theme
 */
export function getFileIconColor(theme, fileType) {
    switch (fileType) {
        case 'pdf':
            return theme.colors.semantic.negative500;
        case 'xls':
            return theme.colors.semantic.positive500;
        case 'doc':
            return theme.colors.semantic.info500;
        case 'ppt':
            return theme.colors.semantic.caution500;
        case 'img':
            return theme.colors.semantic.info500;
        case 'zip':
            return theme.colors.grey[500];
        default:
            return theme.colors.utility.textSecondary;
    }
}

/**
 * Extract the file name and extension from a filename string
 * @param {string} fileName - The full filename with extension
 * @returns {{ name: string, ext: string }} Object with name and extension
 */
export function getFileNameAndExtension(fileName) {
    if (!fileName) return { name: '', ext: '' };
    const lastDotIndex = fileName.lastIndexOf('.');
    const name = lastDotIndex !== -1 ? fileName.substring(0, lastDotIndex) : fileName;
    const ext = lastDotIndex !== -1 ? fileName.substring(lastDotIndex) : '';
    return { ext, name };
}

/**
 * Convert an accept array to react-dropzone format
 * @param {string[]} accept - Array of MIME types or file extensions
 * @returns {object|undefined} Object with MIME types as keys for react-dropzone
 */
export function convertAcceptToDropzoneFormat(accept) {
    if (!accept || !Array.isArray(accept) || accept.length === 0) return undefined;
    return accept.reduce((fileTypes, fileType) => {
        fileTypes[fileType] = [];
        return fileTypes;
    }, {});
}
